<!-- src/app/time-attendance/components/holiday/holiday.component.html -->
<app-config-top-nav></app-config-top-nav>

<div class="holiday-page">
   <div
  class="toast show"
  *ngIf="toastMessage"
  [class.success]="toastKind === 'success'"
  [class.error]="toastKind === 'error'"
  [class.warning]="toastKind === 'info'"
  (click)="clearToast()"
  role="status"
  aria-live="polite"
>
  <img
    class="icon"
    [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'"
    alt=""
    aria-hidden="true"
  />

  <div class="toast-title">
    {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
  </div>

  <div class="toast-body">{{ toastMessage }}</div>
</div>

    <!-- Header -->
    <div class="page-header">
        <div class="title-block">
            <h2>Holiday Booking</h2>
            <p class="subtitle">
                Select a date on the calendar, choose departments if needed, and book holiday hours in advance.
            </p>
        </div>
    </div>

    <!-- Busy overlay -->
    <div *ngIf="isBusy" class="busy-overlay" aria-live="polite" aria-busy="true">
        <div class="spinner"></div>
    </div>

    <section class="holiday-create">
        <div class="create-shell">
            <!-- Left: calendar -->
            <div class="card calendar-card">
                <div class="card-head">
                    <div class="head-left">
                        <h3>Select date</h3>
                        <div class="muted">Choose the holiday date to book.</div>
                    </div>
                </div>

                <div class="month-bar">
                    <button type="button" class="icon-btn" (click)="prevMonth()" aria-label="Previous month">←</button>

                    <button type="button" class="month-label-btn" (click)="openMonthPicker()"
                        [attr.aria-expanded]="isMonthPickerOpen" aria-label="Choose month and year">
                        {{ calendarMonth.format('MMMM YYYY') }}
                        <span class="chev">▾</span>
                    </button>

                    <button type="button" class="icon-btn" (click)="nextMonth()" aria-label="Next month">→</button>
                </div>

                <div class="month-picker" *ngIf="isMonthPickerOpen">
                    <div class="picker-head">
                        <div class="picker-title">Jump to</div>
                        <button type="button" class="ghost-btn small" (click)="closeMonthPicker()">Close</button>
                    </div>

                    <div class="picker-year">
                        <div class="picker-label">Year</div>
                        <div class="year-row">
                            <button type="button" class="year-pill" *ngFor="let y of getPickerYears()"
                                [class.active]="y === pickerYear" (click)="selectPickerYear(y)">
                                {{ y }}
                            </button>
                        </div>
                    </div>

                    <div class="picker-months">
                        <div class="picker-label">Month</div>
                        <div class="month-grid">
                            <button type="button" class="month-pill"
                                *ngFor="let m of getPickerMonthsForYear(pickerYear)"
                                [class.active]="m.index === pickerMonthIndex && pickerYear === calendarMonth.year()"
                                (click)="applyPickerMonth(m.index)">
                                {{ m.label }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="calendar">
                    <div class="dow-row">
                        <div class="dow">Sun</div>
                        <div class="dow">Mon</div>
                        <div class="dow">Tue</div>
                        <div class="dow">Wed</div>
                        <div class="dow">Thu</div>
                        <div class="dow">Fri</div>
                        <div class="dow">Sat</div>
                    </div>

                    <div class="day-grid">
                        <button type="button" class="day-cell" *ngFor="let cell of calendarCells" [class.empty]="!cell"
                            [class.selected]="cell && isSelectedDay(cell)" [disabled]="!cell"
                            (click)="cell && selectDay(cell)">
                            <ng-container *ngIf="cell; else emptyCell">
                                <div class="day-number">{{ cell.date() }}</div>
                            </ng-container>

                            <ng-template #emptyCell>
                                <div class="day-number">&nbsp;</div>
                            </ng-template>
                        </button>
                    </div>

                    <div class="calendar-footer">
                        <div class="meta">
                            Selected:
                            <strong>{{ selectedDateDisplay || 'None' }}</strong>
                        </div>

                        <button type="button" class="ghost-btn small" (click)="resetFormWithConfirm()"
                            [disabled]="!form.appliedDate && !form.departmentIds.length && form.hours === 8">
                            Clear
                        </button>
                    </div>
                </div>
            </div>

            <!-- Right: form -->
            <div class="card details-card">
                <div class="card-head">
                    <div class="head-left">
                        <h3>Holiday form</h3>
                        <div class="muted">Leave departments unselected to apply to the whole company.</div>
                    </div>
                </div>

                <div class="form">
                    <div class="form-row">
                        <label>Selected Date</label>
                        <input type="text" [value]="selectedDateDisplay || 'No date selected'" readonly />
                        <div class="help" *ngIf="selectedWeekLabel">
                            Week: {{ selectedWeekLabel }}
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Hours</label>
                        <input type="number" min="0.25" max="24" step="0.25" [(ngModel)]="form.hours" placeholder="8" />
                    </div>

                    <div class="form-row">
                        <label>Departments</label>

                        <div class="department-summary">
                            <div class="summary-text">
                                {{ form.departmentIds.length ? selectedScopeLabel : 'Applies to all departments' }}
                            </div>

                            <div class="summary-actions">
                                <button type="button" class="ghost-btn small"
                                    (click)="showDepartmentPicker = !showDepartmentPicker">
                                    {{ showDepartmentPicker ? 'Hide departments' : 'Add departments' }}
                                </button>

                                <button type="button" class="ghost-btn small" *ngIf="form.departmentIds.length"
                                    (click)="clearDepartmentSelection()">
                                    Clear
                                </button>
                            </div>
                        </div>

                        <div class="department-picker" *ngIf="showDepartmentPicker">
                            <div class="department-toolbar">
                                <button type="button" class="ghost-btn small" (click)="selectAllDepartments()"
                                    [disabled]="!departments.length || areAllDepartmentsSelected">
                                    Select all
                                </button>
                            </div>

                            <div class="department-options">
                                <label class="department-option"
                                    *ngFor="let department of departments; trackBy: trackDepartment">
                                    <input type="checkbox" [checked]="isDepartmentSelected(department.id)"
                                        (change)="toggleDepartment(department.id)" />
                                    <span>{{ department.label }}</span>
                                </label>
                            </div>
                        </div>

                        <div class="selected-chips" *ngIf="selectedDepartmentNames.length">
                            <span class="chip" *ngFor="let name of selectedDepartmentNames">
                                {{ name }}
                            </span>
                        </div>

                        <div class="help">
                            Leave blank to apply to the entire company.
                        </div>
                    </div>

                    <div class="actions">
                        <button type="button" class="primary-btn" (click)="submitHoliday()" [disabled]="!canSubmit">
                            Book holiday
                        </button>

                        <button type="button" class="ghost-btn" (click)="resetFormWithConfirm()" [disabled]="isBusy">
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Confirm modal -->
    <div class="confirm-backdrop" *ngIf="confirmOpen" (click)="onConfirmCancel()"></div>

    <div class="confirm-modal" *ngIf="confirmOpen" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
        <div class="confirm-header">
            <h3 class="confirm-title">{{ confirmTitle }}</h3>

            <button type="button" class="ghost-btn small" (click)="onConfirmCancel()" aria-label="Close">
                Close
            </button>
        </div>

        <div class="confirm-body">
            <div class="confirm-message">{{ confirmMessage }}</div>
        </div>

        <div class="confirm-actions">
            <button type="button" class="ghost-btn" (click)="onConfirmCancel()">
                {{ confirmCancelText }}
            </button>

            <button type="button" [class.primary-btn]="confirmKind === 'default'"
                [class.danger-btn]="confirmKind === 'danger'" (click)="onConfirmOk()">
                {{ confirmOkText }}
            </button>
        </div>
    </div>
</div>